import styled from 'styled-components';

export const MatchingScoreWrapper = styled.div`
  .ant-progress-circle .ant-progress-inner {
    background-color: #2bada7;
  }
  .ant-progress-circle .ant-progress-text {
    color: #ffffff;
  }
  .ant-progress-inner:not(.ant-progress-circle-gradient)
    .ant-progress-circle-path {
    stroke: #ffffff;
    stroke-width: 8;
  }
  .ant-progress-circle-trail {
    stroke-width: 8;
    opacity: 0.7;
  }
  .progress-style {
    background-color: #2bada7;
    padding: 2px;
    border-radius: 50%;
  }
`;
